import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import SectionTitle from "../components/Common/SectionTitle";

import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";
import FeedbackForm from "../components/Forms/FeedbackForm";

export default function Feedback() {
  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={"Feedback"}
      />
      <section className="referrels-section-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={12}>
              <div className="">
                <SectionTitle
                  align={"left"}
                  subTitle={"Feedback"}
                  subtitle={false}
                  Title={"Feedback"}
                />
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-lg-5 mb-lg-5 mt-0 mb-0">
            <CCol lg={12}>
              <div className="referrels-form-card-wrapper">
                <FeedbackForm />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
